// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Routing
import { ErrorsRoutingModule } from './errors-routing.module';
// Modules
import { MedsurfCommonModule } from '../common/medsurf-common.module';
// Components
import { ErrorsComponent } from './errors.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Translate
    TranslateModule.forChild(),
    // Routing
    ErrorsRoutingModule,
    // Modules
    MedsurfCommonModule,
  ],
  declarations: [
    // Components
    ErrorsComponent,
  ],
})
export class ErrorsModule { }
